define.alias("shared/helpers/format-profile-categorization-value", "settings/helpers/format-profile-categorization-value");